import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import Dialog from 'components/common/Dialog';
import focusManager from 'support/focus/FocusManager';
import { hideIdleMode } from 'actions/idleMode';
import { VideoCtvRedux } from 'store-types';

const messages = {
  idleModeTitle: {
    id: 'idleMode.title',
    description: 'Idle mode overlay message',
  },
  idleModeMessage: {
    id: 'idleMode.message',
    description: 'Idle mode overlay message',
  },
  exitLabel: {
    id: 'exit.page.label',
    description: 'Exit dialog label',
  },
  exitConfirmation: {
    id: 'exit.page.confirmation',
    description: 'Exit dialog message',
  },
  exitYes: {
    id: 'exit.page.button.yes',
    description: 'Exit dialog confirm button',
  },
  exitNo: {
    id: 'exit.page.button.no',
    description: 'Exit dialog cancel button',
  },
};

const FIRST_CAROUSEL_ITEM_FOCUS_ID = 'home-carousel-0';

const IdleModeOverlay: React.FC = () => {
  const [isWasViewed, setIsWasViewed] = useState<boolean>(false)
  const dispatch = useDispatch();
  const intl = useIntl();
  const showOverlay = useSelector((state: VideoCtvRedux) => state.idleMode.showOverlay);

  useEffect(() => {
    if (!showOverlay) {
      return undefined;
    }

    const dismiss = (event: Event): void => {
      setIsWasViewed(true);
      event.stopImmediatePropagation();
      dispatch(hideIdleMode());
      focusManager.setCurrentFocus(FIRST_CAROUSEL_ITEM_FOCUS_ID);
    };
    document.addEventListener('keydown', dismiss, true);
    document.addEventListener('pointerdown', dismiss, true);
    return () => {
      document.removeEventListener('keydown', dismiss, true);
      document.removeEventListener('pointerdown', dismiss, true);
    };
  }, [showOverlay, dispatch, setIsWasViewed]);

  if (isWasViewed) {
    return null;
  }

  return (
    <Dialog
      isOpen={showOverlay}
      title={intl.formatMessage(messages.idleModeTitle)}
      message={intl.formatMessage(messages.idleModeMessage)}
      onActionOverride={() => {
        return true;
      }}
      positiveCTA={intl.formatMessage(messages.exitYes)}
      negativeCTA={intl.formatMessage(messages.exitNo)}
      initialFocus="negative"
    />
  );
};

export default React.memo(IdleModeOverlay);
